import { render, staticRenderFns } from "./server-name.vue?vue&type=template&id=26f013cb&scoped=true&"
import script from "./server-name.vue?vue&type=script&lang=js&"
export * from "./server-name.vue?vue&type=script&lang=js&"
import style0 from "./server-name.vue?vue&type=style&index=0&id=26f013cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f013cb",
  null
  
)

export default component.exports